import { createFileRoute } from "@tanstack/react-router";

import { LoginPage } from "../components/auth/LoginPage";

export const Route = createFileRoute("/login")({
  head: () => ({ meta: [{ name: "robots", content: "noindex" }] }),
  component: LoginPage,
  validateSearch: (search: Record<string, unknown>) => ({
    returnTo: typeof search.returnTo === "string" ? search.returnTo : undefined,
    ...(search.ssoCallback === "true" ? { ssoCallback: "true" } : {}),
  }),
});
